import { baseApi } from './baseApi';

export const tradeInApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTradeIns: builder.query({
      query: (params) => ({
        url: '/trade-ins',
        params,
      }),
      providesTags: ['TradeInTicket'],
    }),
    getTradeInById: builder.query({
      query: (id) => `/trade-ins/${id}`,
      providesTags: (result, error, id) => [{ type: 'TradeInTicket', id }],
    }),
    createTradeIn: builder.mutation({
      query: (data) => ({
        url: '/trade-ins',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['TradeInTicket'],
    }),
    updateTradeIn: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/trade-ins/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'TradeInTicket', id },
        'TradeInTicket'
      ],
    }),
    completeTradeIn: builder.mutation({
      query: (id) => ({
        url: `/trade-ins/${id}/complete`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'TradeInTicket', id },
        'TradeInTicket',
        'ProductImei',
        'RegisterSession',
      ],
    }),
  }),
});

export const {
  useGetTradeInsQuery,
  useGetTradeInByIdQuery,
  useCreateTradeInMutation,
  useUpdateTradeInMutation,
  useCompleteTradeInMutation,
} = tradeInApi;
